import type { Pictogram } from '../pictogram';

export const PairIcon: Pictogram = ({ width = 80, height = 80, ...props }) => (
  <svg width={width} height={height} {...props} viewBox='0 0 80 80' xmlns='http://www.w3.org/2000/svg'>
    <title>Deux personnes assises avec leurs ordinateurs</title>
    <path
      d='M54.4 39.1c-4.2 0-7.6-3.4-7.6-7.6s3.4-7.6 7.6-7.6 7.6 3.4 7.6 7.6-3.4 7.6-7.6 7.6m0-13.2c-3.1 0-5.6 2.5-5.6 5.6s2.5 5.6 5.6 5.6 5.6-2.5 5.6-5.6-2.5-5.6-5.6-5.6m-.3 27.8H49c-1 0-1.7-.8-1.7-1.7v-2.7c0-.6.4-1 1-1s1 .4 1 1v2.5h4.8c.6 0 1 .4 1 1s-.4.9-1 .9'
      className='artwork-major'
    />
    <path
      d='M52.5 59.4h-6c-2.8 0-5-2.2-5-5v-5.6c0-4.4 3.6-8 8-8h9.6c2 0 4 .8 5.5 2.2.4.4.4 1 0 1.4s-1 .4-1.4 0c-1.1-1-2.6-1.6-4.1-1.6h-9.6c-3.3 0-6 2.7-6 6v5.6c0 1.7 1.4 3 3 3h6c.6 0 1 .4 1 1s-.4 1-1 1m-1.2 4.5h-7.6c-.6 0-1-.4-1-1s.4-1 1-1h7.6c.6 0 1 .4 1 1s-.5 1-1 1M25.6 29.2c-4.2 0-7.6-3.4-7.6-7.6s3.4-7.6 7.6-7.6 7.6 3.4 7.6 7.6-3.4 7.6-7.6 7.6m0-13.1c-3.1 0-5.6 2.5-5.6 5.6s2.5 5.6 5.6 5.6 5.6-2.5 5.6-5.6-2.5-5.6-5.6-5.6m5.3 27.7h-5.1c-.6 0-1-.4-1-1s.4-1 1-1h4.8v-2.5c0-.6.4-1 1-1s1 .4 1 1V42c.1 1-.7 1.8-1.7 1.8'
      className='artwork-major'
    />
    <path
      d='M33.4 49.6h-6c-.6 0-1-.4-1-1s.4-1 1-1h6c1.7 0 3-1.4 3-3V39c0-3.3-2.7-6-6-6h-9.6c-1.5 0-3 .6-4.1 1.6-.4.4-1 .4-1.4 0s-.4-1 0-1.4c1.5-1.4 3.4-2.2 5.5-2.2h9.6c4.4 0 8 3.6 8 8v5.6c0 2.7-2.2 5-5 5m3 4.5h-7.6c-.6 0-1-.4-1-1s.4-1 1-1h7.6c.6 0 1 .4 1 1s-.5 1-1 1'
      className='artwork-major'
    />
    <path
      d='M28.7 54.1H9.4c-.4 0-.8-.3-1-.7L4.1 38.3c-.1-.3 0-.6.2-.9.2-.2.5-.4.8-.4h19.4c.4 0 .8.3 1 .7l4.3 15.1c.1.3 0 .6-.2.9s-.5.4-.9.4m-18.6-2h17.3L23.7 39H6.4zm60.5 11.8H51.3c-.3 0-.6-.1-.8-.4-.2-.2-.2-.6-.2-.9l4.3-15.1c.1-.4.5-.7 1-.7H75c.3 0 .6.1.8.4.2.2.2.6.2.9l-4.3 15.1c-.2.4-.6.7-1.1.7m-18-2h17.3l3.7-13.1H56.3z'
      className='artwork-minor'
    />
  </svg>
);
